export const TIMBERLINE_TOOLS = [
  'Alignment Jog',
  'EVO2 Disconnect Tool',
  'GAF FlexSeal Caulk Grade Sealant',
];

export const MATERIALS_FILE_PATH = {
  TIMBERLINE: '/assets/material_lists/Timberline Tools and Materials.pdf',
  DECOTECH: '/assets/material_lists/DecoTech 2.0 Install Tool List.pdf',
};
